import { actionCreators as summaryReportEditorActionCreators } from "Areas/SummaryReports/summaryReportEditorPanel";
import { Permissions, security } from "Common/permissions";
import { connect } from "react-redux";
import actionCreators from "../redux/actionCreators";
import { getProjectSummaryReports } from "../redux/selectors";
import SummaryReportList from "./summaryReportList";
const canEdit = security.isAllowed([Permissions.SummaryReportsEdit]);
const mapStateToProps = (state) => ({
    data: getProjectSummaryReports(state),
    canEdit
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: (projectId) => dispatch(actionCreators.getProjectSummaryReports(projectId)),
    onOpenSummaryReportCreatorPanel: (projectId) => dispatch(summaryReportEditorActionCreators.setNewSummaryReport(projectId))
});
export default connect(mapStateToProps, mapDispatchToProps)(SummaryReportList);
